import React from 'react';
import PropTypes from 'prop-types';
import { TableBody } from '@mui/material';
import GenericEntityFlowEditStatesRow from './GenericEntityFlowEditStatesRow';
import { sequence, get } from '@totalsoft/change-tracking-react';

const GenericEntityFlowEditStatesBody = ({
  genericEntityFlowStatesLens,
  genericEntityBusinessStates,
  onDelete,
  validation
}) => {
  return (
    <TableBody>
      {genericEntityFlowStatesLens &&
        (genericEntityFlowStatesLens |> get).length > 0 &&
        (genericEntityFlowStatesLens |> sequence).map((data, index) => {
        return (
          <GenericEntityFlowEditStatesRow
            genericEntityBusinessStates={genericEntityBusinessStates}
            genericEntityFlowStateLens={data}
            key={`${data.stateId |> get}_${index}`}
            index={index}
            onDelete={onDelete}
            validation={validation}
          />
        );
      })}
    </TableBody>
  );
};

GenericEntityFlowEditStatesBody.propTypes = {
  genericEntityFlowStatesLens: PropTypes.object.isRequired,
  genericEntityBusinessStates: PropTypes.array,
  onDelete: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired
};

export default GenericEntityFlowEditStatesBody;
